import { Injectable } from "@angular/core";

@Injectable()
export class BookingCredentials {
    
      public lastname: string = "";
      public bookingcode: string = "";
     
  }
